import React, { useState, useEffect } from "react";
import { Box, Button, Typography, CircularProgress, Dialog, DialogTitle, DialogContent, DialogActions, TextField, MenuItem, IconButton,Table, TableHead, TableBody, TableRow, TableCell
 } from "@mui/material";
import { startShift, endShift, handoverShift, executeCheckActiveDailyshift, getShiftTitles, getActiveShiftTransactions, getActiveShiftData } from "../../../services/Settings/ServicesandTaxSettingsAndSessios/SessoinAndShiftsApi";
import { fetchBanks } from "../../../services/pos/Tables"; // Import fetchBanks function
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong"; // أيقونة للمعاملات
import { getUserShiftReport } from "../../../services/Reports/ReportsApi";
import PrintIcon from "@mui/icons-material/Print";

const ShiftActions = () => {
  const [loading, setLoading] = useState(false);
  const [shiftActive, setShiftActive] = useState(() => {
    return localStorage.getItem("shift_started") === "true";
  });
  const [sessionStatus, setSessionStatus] = useState(null); // Track session status
  const [banks, setBanks] = useState([]); // State to store banks
  const [error, setError] = useState(""); // State to track errors
  const [handoverModalOpen, setHandoverModalOpen] = useState(false);
  const [startShiftModalOpen, setStartShiftModalOpen] = useState(false); // ✅ Modal for entering shift ID
  const [shiftData, setShiftData] = useState({
    shiftId: "",
    rootId: localStorage.getItem("branch_id") || "",
  });
  const [handoverData, setHandoverData] = useState({
    from_bank_id: "",
    to_bank_id: "",
    amount: "100",
  });
  const [shifts, setShifts] = useState([]); // ✅ State to store shift titles
  const [activeShiftCashTotal, setActiveShiftCashTotal] = useState(null);
  const [showTransactionsDialog, setShowTransactionsDialog] = useState(false);
  const [selectedShift, setSelectedShift] = useState(null);
  const [shiftTransactions, setShiftTransactions] = useState([]);
  const [transactionsLoading, setTransactionsLoading] = useState(false);
  const [activeShiftId, setActiveShiftId] = useState("");
  const [printConfirmOpen, setPrintConfirmOpen] = useState(false);
  const [printUserName, setPrintUserName] = useState("");
  const [printMode, setPrintMode] = useState(false);
  const [endConfirmOpen, setEndConfirmOpen] = useState(false);
  const [printBeforeEndOpen, setPrintBeforeEndOpen] = useState(false);
  const [printTransactions, setPrintTransactions] = useState([]);

  useEffect(() => {
    // ✅ جلب حالة الشيفت من الـ API فقط
    const fetchShiftStatus = async () => {
      try {
        const status = await executeCheckActiveDailyshift();
        setShiftActive(status === "active");
        setSessionStatus(status);
      } catch (error) {
        setSessionStatus("تعذر جلب حالة الشيفت");
      }
    };

    const fetchBanksList = async () => {
      try {
        const data = await fetchBanks();
        setBanks(data);
      } catch (err) {
        setError("❌ فشل في جلب الخزن.");
      }
    };

    const fetchShiftTitles = async () => {
      try {
        const rootId = localStorage.getItem("branch_id");
        if (!rootId) throw new Error("❌ لم يتم العثور على branch_id.");
        const titles = await getShiftTitles(rootId);
        setShifts(titles);
      } catch (err) {
        console.error("❌ فشل في جلب أسماء الشيفتات:", err.message);
      }
    };

    const fetchActiveShiftCash = async () => {
      try {
        // جلب sessionId من localStorage أو منطقك الخاص
        const sessionId = localStorage.getItem("active_session_id");
        if (sessionId) {
          const txs = await getActiveShiftTransactions(sessionId);
          setActiveShiftCashTotal(txs.total_invoice_amount || 0);
        }
      } catch (err) {
        setActiveShiftCashTotal(null);
      }
    };

    const fetchActiveShiftId = async () => {
      try {
        const activeShifts = await getActiveShiftData();
        // توقع أن الدالة ترجع مصفوفة، خذ أول شيفت نشط
        if (Array.isArray(activeShifts) && activeShifts.length > 0) {
          setActiveShiftId(activeShifts[0].id);
        } else {
          setActiveShiftId("");
        }
      } catch (err) {
        setActiveShiftId("");
      }
    };

    fetchShiftStatus();
    fetchBanksList();
    fetchShiftTitles();
    fetchActiveShiftCash();
    fetchActiveShiftId();
  }, []);

  const handleStartShift = async () => {
    setLoading(true);
    try {
      await startShift(shiftData.shiftId, shiftData.rootId);
      localStorage.setItem("active_shift_id", shiftData.shiftId);
      alert("تم بدء الشيفت بنجاح.");
      setShiftActive(true);
      localStorage.setItem("shift_started", "true");
      setStartShiftModalOpen(false); // ✅ Close the modal
    } catch (error) {
      alert("فشل في بدء الشيفت.");
    } finally {
      setLoading(false);
    }
  };

  const handleEndShift = async () => {
    // قبل السؤال عن إنهاء الشيفت، اسأل أولاً عن الطباعة
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setPrintUserName(user?.username || "");
    setPrintBeforeEndOpen(true);
  };

  const handlePrintBeforeEnd = (shouldPrint) => {
    setPrintBeforeEndOpen(false);
    if (shouldPrint) {
      handlePrintTransactions();
    }
    setEndConfirmOpen(true); // بعد الطباعة أو تخطيها، اسأل عن إنهاء الشيفت
  };

  const confirmEndShift = async () => {
    setLoading(true);
    try {
      await endShift();
      alert("تم إنهاء الشيفت بنجاح.");
      setShiftActive(false);
      localStorage.setItem("shift_started", "false");
    } catch (error) {
      alert("فشل في إنهاء الشيفت.");
    } finally {
      setLoading(false);
      setEndConfirmOpen(false);
    }
  };

  const handleHandoverShift = async () => {
    setHandoverModalOpen(true); // Open the modal
  };

  const handleHandoverSubmit = async () => {
    setLoading(true);
    try {
      await handoverShift(handoverData);
      alert("تم قفل الشيفت وترحيل النقدية بنجاح.");
      setShiftActive(false);
      localStorage.setItem("shift_started", "false");
      setHandoverModalOpen(false);
      askPrintReport();
    } catch (error) {
      alert("فشل في قفل الشيفت وترحيل النقدية.");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setShiftData((prev) => ({ ...prev, [name]: value }));
  };

  const handleHandoverChange = (e) => {
    const { name, value } = e.target;
    setHandoverData((prev) => ({ ...prev, [name]: value }));
  };

  
const handleShowTransactions = async () => {
  const userId = localStorage.getItem("user_id");
  const shiftId = activeShiftId;

  if (!userId || !shiftId) {
    setShiftTransactions([]);
    setShowTransactionsDialog(true);
    return;
  }

  setShowTransactionsDialog(true);
  setTransactionsLoading(true);
  try {
    const result = await getUserShiftReport(userId, shiftId);
    // ✅ المعاملات موجودة تحت result.transactions مباشرة
    setShiftTransactions(Array.isArray(result?.transactions) ? result.transactions : []);
  } catch (err) {
    console.error("❌ خطأ في جلب معاملات الشيفت:", err.message);
    setShiftTransactions([]);
  } finally {
    setTransactionsLoading(false);
  }
};

  const handlePrintTransactions = async () => {
    // جلب بيانات المعاملات من getUserShiftReport قبل الطباعة
    const userId = localStorage.getItem("user_id");
    const shiftId = activeShiftId;
    let transactions = [];
    if (userId && shiftId) {
      try {
        const result = await getUserShiftReport(userId, shiftId);
        transactions = Array.isArray(result?.transactions) ? result.transactions : [];
      } catch (err) {
        transactions = [];
      }
    }
    setPrintTransactions(transactions);
    setPrintMode(true);
    setTimeout(() => {
      window.print();
      setPrintMode(false);
    }, 100);
  };

  const askPrintReport = () => {
    // جلب اسم المستخدم من اللوكال ستورج
    const user = JSON.parse(localStorage.getItem("user") || "{}");
    setPrintUserName(user?.username || "");
    setPrintConfirmOpen(true);
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
      <Typography variant="h6">إدارة الشيفتات</Typography>
      <Typography variant="body2" color="textSecondary">
        حالة اليومية: {sessionStatus || "جاري التحميل..."}
      </Typography>
      {error && (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      )}
      <Typography variant="body2" color="textSecondary">
        الخزن المتاحة:
      </Typography>
      <ul>
        {banks.map((bank) => (
          <li key={bank.id}>{bank.name}</li>
        ))}
      </ul>
      {/* عرض إجمالي النقدية من الشيفت النشط */}
      {activeShiftCashTotal !== null && (
        <Typography
          variant="h6"
          sx={{
            color: "#43a047",
            fontWeight: 900,
            fontSize: 22,
            letterSpacing: 1,
            mb: 1,
          }}
        >
          إجمالي النقدية بالشيفت النشط: {activeShiftCashTotal.toLocaleString()} ج.م
        </Typography>
      )}
      {loading ? (
        <CircularProgress />
      ) : shiftActive ? (
        <Box display="flex" flexDirection="column" gap={2}>
          <Button variant="contained" color="secondary" onClick={handleEndShift}>
            قفل الشيفت
          </Button>
          <Button variant="contained" color="error" onClick={() => setHandoverModalOpen(true)}>
            قفل الشيفت وترحيل النقدية
          </Button>
        </Box>
      ) : (
        <Button variant="contained" color="primary" onClick={() => setStartShiftModalOpen(true)}>
          بداية الشيفت
        </Button>
      )}

      {/* اسم الشيفت وأيقونة عرض المعاملات تظهر فقط إذا كان الشيفت مفتوح */}
      {shiftActive && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2 }}>
          <Typography variant="body1" fontWeight="bold">
            اسم الشيفت الحالي: {
              (() => {
                const activeShift = shifts.find(s => String(s.id) === String(activeShiftId));
                return activeShift?.title || "غير محدد";
              })()
            }
          </Typography>
          <IconButton
            color="primary"
            onClick={handleShowTransactions}
            disabled={!shiftActive || !activeShiftId}
          >
            <ReceiptLongIcon />
          </IconButton>
          <Typography variant="caption">عرض معاملات الشيفت</Typography>
        </Box>
      )}

      {/* Start Shift Modal */}
      <Dialog open={startShiftModalOpen} onClose={() => setStartShiftModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>بداية الشيفت</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
        <TextField
  select
  label="اختر الشيفت"
  name="shiftId"
  value={shiftData.shiftId}
  onChange={handleInputChange}
  fullWidth
>
  {shifts.map((shift) => (
    <MenuItem key={shift.id} value={shift.id}>
  {shift.title || "بدون اسم"}
</MenuItem>

  ))}
</TextField>

          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setStartShiftModalOpen(false)} variant="outlined">
            إلغاء
          </Button>
          <Button onClick={handleStartShift} variant="contained" color="primary">
            بدء الشيفت
          </Button>
        </DialogActions>
      </Dialog>

      {/* Handover Modal */}
      <Dialog open={handoverModalOpen} onClose={() => setHandoverModalOpen(false)} fullWidth maxWidth="sm">
        <DialogTitle>ترحيل النقدية</DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" gap={2}>
            <TextField
              select
              label="من الخزنة"
              name="from_bank_id"
              value={handoverData.from_bank_id}
              onChange={(e) => setHandoverData((prev) => ({ ...prev, from_bank_id: e.target.value }))}
              fullWidth
            >
              {banks.map((bank) => (
                <MenuItem key={bank.id} value={bank.id}>
                  {bank.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              select
              label="إلى الخزنة"
              name="to_bank_id"
              value={handoverData.to_bank_id}
              onChange={(e) => setHandoverData((prev) => ({ ...prev, to_bank_id: e.target.value }))}
              fullWidth
            >
              {banks.map((bank) => (
                <MenuItem key={bank.id} value={bank.id}>
                  {bank.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="المبلغ"
              name="amount"
              type="text"
              value={handoverData.amount}
              onChange={(e) => setHandoverData((prev) => ({ ...prev, amount: e.target.value }))}
              fullWidth
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setHandoverModalOpen(false)} variant="outlined">
            إلغاء
          </Button>
          <Button onClick={handleHandoverSubmit} variant="contained" color="primary">
            ترحيل
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog عرض معاملات الشيفت */}
      <Dialog open={showTransactionsDialog} onClose={() => setShowTransactionsDialog(false)} fullWidth maxWidth="md">
  <DialogTitle>معاملات الشيفت</DialogTitle>
  <DialogContent>
    {transactionsLoading ? (
      <CircularProgress />
    ) : shiftTransactions.length === 0 ? (
      <Typography color="text.secondary">لا توجد معاملات لهذا الشيفت.</Typography>
    ) : (
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>رقم العملية</TableCell>
            <TableCell>النوع</TableCell>
            <TableCell>المبلغ</TableCell>
            <TableCell>الخزنة</TableCell>
            <TableCell>العميل</TableCell>
            <TableCell>نوع الأوردر</TableCell>
            <TableCell>التاريخ</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {shiftTransactions.map((tx) => (
            <TableRow key={tx.id}>
              <TableCell>{tx.id}</TableCell>
              <TableCell>{tx.type}</TableCell>
              <TableCell>{tx.amount} ج.م</TableCell>
              <TableCell>{tx.bank?.name || "غير محدد"}</TableCell>
              <TableCell>{tx.invoice?.customer?.name || "بدون عميل"}</TableCell>
              <TableCell>{tx.invoice?.order?.order_type || "-"}</TableCell>
              <TableCell>{tx.transaction_date}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    )}
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setShowTransactionsDialog(false)} variant="outlined">
      إغلاق
    </Button>
  </DialogActions>
</Dialog>

      {/* Dialog تأكيد طباعة تقرير الشيفت */}
      <Dialog open={printConfirmOpen} onClose={() => setPrintConfirmOpen(false)} maxWidth="xs" fullWidth>
  <DialogTitle sx={{ textAlign: "center" }}>تأكيد طباعة تقرير الشيفت</DialogTitle>
  <DialogContent sx={{ textAlign: "center" }}>
    <Typography>
      هل تريد طباعة تقرير معاملات الشيفت لهذا المستخدم؟
      <br />
      اسم المستخدم: <b>{printUserName}</b>
    </Typography>
  </DialogContent>
  <DialogActions sx={{ justifyContent: "center" }}>
    <Button onClick={() => setPrintConfirmOpen(false)} color="secondary">
      لا
    </Button>
    <Button
      onClick={() => {
        setPrintConfirmOpen(false);
        handlePrintTransactions();
      }}
      color="primary"
      variant="contained"
    >
      نعم، اطبع التقرير
    </Button>
  </DialogActions>
</Dialog>

      {/* Dialog السؤال عن طباعة تقرير المستخدم قبل إنهاء الشيفت */}
      <Dialog open={printBeforeEndOpen} onClose={() => setPrintBeforeEndOpen(false)} maxWidth="xs" fullWidth>
  <DialogTitle sx={{ textAlign: "center" }}>تأكيد طباعة تقرير الشيفت</DialogTitle>
  <DialogContent sx={{ textAlign: "center" }}>
    <Typography>
      هل تريد طباعة تقرير معاملات الشيفت لهذا المستخدم؟
      <br />
      اسم المستخدم: <b>{printUserName}</b>
    </Typography>
  </DialogContent>
  <DialogActions sx={{ justifyContent: "center" }}>
    <Button onClick={() => handlePrintBeforeEnd(false)} color="secondary">
      لا
    </Button>
    <Button
      onClick={() => handlePrintBeforeEnd(true)}
      color="primary"
      variant="contained"
    >
      نعم، اطبع التقرير
    </Button>
  </DialogActions>
</Dialog>

      {/* Dialog تأكيد إنهاء الشيفت */}
      <Dialog open={endConfirmOpen} onClose={() => setEndConfirmOpen(false)} maxWidth="xs" fullWidth>
  <DialogTitle sx={{ textAlign: "center" }}>تأكيد إنهاء الشيفت</DialogTitle>
  <DialogContent sx={{ textAlign: "center" }}>
    <Typography>
      هل أنت متأكد أنك تريد إنهاء الشيفت الحالي؟
    </Typography>
  </DialogContent>
  <DialogActions sx={{ justifyContent: "center" }}>
    <Button onClick={() => setEndConfirmOpen(false)} color="secondary">
      إلغاء
    </Button>
    <Button
      onClick={confirmEndShift}
      color="primary"
      variant="contained"
    >
      نعم، إنهاء الشيفت
    </Button>
  </DialogActions>
</Dialog>

      {/* صفحة الطباعة الاحترافية */}
      {printMode && (
        <Box
          id="print-area"
          sx={{
            display: "block",
            position: "absolute",
            left: 0,
            top: 0,
            width: "100vw",
            bgcolor: "#fff",
            color: "#232334",
            zIndex: 9999,
            p: 4,
            fontFamily: "Cairo, Arial, sans-serif",
          }}
        >
          <Typography variant="h4" align="center" sx={{ mb: 2, fontWeight: "bold", color: "#1976d2", fontSize: 36 }}>
            تقرير معاملات الشيفت
          </Typography>
          <Typography variant="h6" align="center" sx={{ mb: 2, fontWeight: "bold", fontSize: 28 }}>
            اسم الشيفت: {selectedShift?.title || "غير محدد"}
          </Typography>
          <Typography align="center" sx={{ mb: 2, fontWeight: "bold", fontSize: 22 }}>
            اسم المستخدم: <b>{printUserName}</b>
          </Typography>
          <Table sx={{ mb: 2 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>رقم العملية</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>النوع</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>المبلغ</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>الخزنة</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>العميل</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>نوع الأوردر</TableCell>
                <TableCell sx={{ fontWeight: "bold", fontSize: 20 }}>التاريخ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(printTransactions.length > 0 ? printTransactions : shiftTransactions).map((tx) => (
                <TableRow key={tx.id}>
                  <TableCell sx={{ fontSize: 18 }}>{tx.id}</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.type}</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.amount} ج.م</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.bank?.name || "غير محدد"}</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.invoice?.customer?.name || "بدون عميل"}</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.invoice?.order?.order_type || "-"}</TableCell>
                  <TableCell sx={{ fontSize: 18 }}>{tx.transaction_date}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Typography align="center" sx={{ mt: 3, fontSize: 20, fontWeight: "bold" }}>
            تم الطباعة بتاريخ: {new Date().toLocaleString("ar-EG")}
          </Typography>
        </Box>
      )}

      <style>
        {`
          @media print {
            body * {
              visibility: hidden !important;
            }
            #print-area, #print-area * {
              visibility: visible !important;
            }
            #print-area {
              position: absolute !important;
              left: 0 !important;
              top: 0 !important;
              width: 100vw !important;
              background: #fff !important;
              color: #232334 !important;
              z-index: 99999 !important;
              font-size: 20px !important;
              font-family: Cairo, Arial, sans-serif !important;
            }
            #print-area table, #print-area th, #print-area td {
              font-size: 18px !important;
              font-weight: bold !important;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default ShiftActions;
